import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/change-password';

@Injectable({
  providedIn: 'root'
})
export class UserChangePasswordService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
